import { render } from "./MiniKoko.vue?vue&type=template&id=4a35f328&scoped=true"
import script from "./MiniKoko.vue?vue&type=script&lang=js"
export * from "./MiniKoko.vue?vue&type=script&lang=js"

import "./MiniKoko.vue?vue&type=style&index=0&id=4a35f328&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a35f328"]])

export default __exports__